export const eSupportedByHostFeature = {
  UNSET: { value: 0, name: 'Unset' },
  EPS_UNINSTALL_PASSWORD: { value: 1, name: 'Eps Msi Uninstall Password' },
  DRIVER_V2: { value: 2, name: 'Driver V2' }
};
